var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCheckBox = function SvgCheckBox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.53 9.79-8.41 8.71-.28 1.44h-1.5l-.28-1.44-4.59-4.71a.193.193 0 0 0-.28 0l-1.13 1.13c-.08.08-.08.2 0 .28l6.89 7.01c.08.08.2.08.28 0L24.94 11.2c.08-.08.08-.2 0-.28l-1.13-1.13a.193.193 0 0 0-.28 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 32H.2a.2.2 0 0 1-.2-.2V.2C0 .09.09 0 .2 0h31.6c.11 0 .2.09.2.2v31.6a.2.2 0 0 1-.2.2M2.2 30h27.6a.2.2 0 0 0 .2-.2V2.2a.2.2 0 0 0-.2-.2H2.2a.2.2 0 0 0-.2.2v27.6c0 .11.09.2.2.2"
  })));
};
export default SvgCheckBox;